module.exports = __webpack_public_path__ + "static/img_1692-6eb9569824ab9d3543f54880fbd150cb.jpg";